import React, { ReactNode, useMemo, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import styled from '@emotion/styled';

import { COLORS_BASE } from '../../utils/consts';

type TooltipWrapperProps = {
    children: ReactNode,
    content?: string,
    positionFromDivBottom?: string,
    margin?: string,
    positionBelow?: boolean,
    activeTooltip?: boolean,
}

function TooltipWrapper({ activeTooltip = true, children, content = 'test', positionFromDivBottom = '22px', margin = '0', positionBelow = false}: TooltipWrapperProps) {
    const wrapperRef = useRef<HTMLDivElement | null>(null);
    const [isTooltipVisible, setIsTooltipVisible] = useState(false);

    const tooltipPosition = useMemo(() => {
        if (!wrapperRef.current) return null;

        const rect = wrapperRef.current.getBoundingClientRect();
        const parsedOffset = parseInt(positionFromDivBottom, 10);
        const verticalOffset = Number.isNaN(parsedOffset) ? 22 : parsedOffset;

        return {
            top: positionBelow ? rect.bottom + 8 : rect.top - verticalOffset,
            left: rect.left + 5,
        };
    }, [isTooltipVisible, positionBelow, positionFromDivBottom]);

    if(!activeTooltip) return <>{children}</>;

    return (
        <TooltipPositionStyle>
            <TooltipWrapperStyle
                ref={wrapperRef}
                margin={margin}
                onMouseEnter={() => setIsTooltipVisible(true)}
                onMouseLeave={() => setIsTooltipVisible(false)}
                onFocus={() => setIsTooltipVisible(true)}
                onBlur={() => setIsTooltipVisible(false)}
            >
                {children}
            </TooltipWrapperStyle>
            {isTooltipVisible && tooltipPosition && createPortal(
                <TooltipContentStyle style={{ top: `${tooltipPosition.top}px`, left: `${tooltipPosition.left}px` }}>
                    {content}
                </TooltipContentStyle>,
                document.body
            )}
        </TooltipPositionStyle>
    )
}

export default TooltipWrapper;

const TooltipPositionStyle = styled.div<{}>(() => `
    display: flex;
    justify-content: flex-end;
`)

const TooltipWrapperStyle = styled.div<{ margin: string }>(
    ({ margin }) => `
    margin: ${margin};
    color: inherit;
    position: relative;
    height: fit-content;
`)

const TooltipContentStyle = styled.div(() => `
    position: fixed;
    width: 200px;
    font-size: 14px;
    background-color: ${COLORS_BASE.BRAND.MAIN};
    color: ${COLORS_BASE.GREYS.MAIN};
    padding: 3px 5px;
    border-radius: 3px;
    height: fit-content;
    z-index: 9999;
    pointer-events: none;
`)